import React from 'react';

import { PreloadImageLink } from '../../../../components/PreloadImageLink';
import { SeoBlock } from '../../../../components/SeoBlock';
import { Pathway } from '../../../../types';
import { DEFAULT_URL } from '../../../DiscoverPage/const';

interface PathwayPageSeoBlockProps {
  pathway?: Pathway | null;
  tenantTitle?: string | null;
}

const PathwayPageSeoBlock: React.FC<PathwayPageSeoBlockProps> = ({ pathway, tenantTitle }) => {
  const url = `${process.env.REACT_APP_WP_URL}/discover/pathways/${pathway?.slug}/`;

  return (
    <>
      <SeoBlock
        data={{
          seo_title: `${pathway?.name} ${tenantTitle ? ' - ' + tenantTitle : ''}`,
          seo_description: pathway?.description,
          share_image: pathway?.image_url,
          author: 'Finance Unlocked',
          url,
        }}
        canonicalUrl={`${DEFAULT_URL}/pathways/${pathway?.slug}`}
      />
      <PreloadImageLink path={pathway?.image_url} />
    </>
  );
};

export default PathwayPageSeoBlock;
